import store from "../store";
import supsisImg from "../assets/img/logo2.png";
import { i18n } from "../language";

export const enableDesktopNotification = () => {
    return new Promise((resolve, reject) => {
        if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
            reject(false);
        }

        // Let's check whether notification permissions have already been granted
        else if (Notification.permission === "granted") {
            // If it's okay let's create a notification
            const notification = new Notification(i18n.tc("message.notificationEnabled"), {
                icon: supsisImg,
                body: i18n.tc("message.notificationDisable"),
            });
            resolve(true);
        }

        // Otherwise, we need to ask the user for permission
        else if (Notification.permission !== "denied") {
            Notification.requestPermission().then(function (permission) {
                // If the user accepts, let's create a notification
                if (permission === "granted") {
                    const notification = new Notification(i18n.tc("message.notificationEnabled"), {
                        icon: supsisImg,
                        body: i18n.tc("message.notificationDisable"),
                    });
                    resolve(true);
                } else {
                    reject("denied");
                }
            });
        } else if (Notification.permission === "denied") {
            reject("denied");
        }
    });
};

export const sendDesktopNotification = (message, index) => {
    const isNotificationEnabled = store.state.auth.user.notificationSettings[index].desktopNotification;
    if (Notification.permission === "granted" && !store.state.app.tabVisible && isNotificationEnabled) {
        const notification = new Notification(message, {
            icon: supsisImg,
        });
        notification.onclick = function (event) {
            window.focus();
        };
    }
};
